import type {GlossaryItem} from '../../../generated/types';
import {GlossaryTypes} from '../../../components/enums';
import {composeDescription} from '../../../lib/seo/text';
import type {OgCardData} from '../../../lib/seo/site';

/** «Состояние», «Действие»… или просто «Термин» */
export function glossaryTypeText(item: Pick<GlossaryItem, 'type'>): string {
	return (item.type && GlossaryTypes[item.type]) || 'Термин';
}

export function glossaryDescription(item: GlossaryItem): string {
	return composeDescription(`${glossaryTypeText(item)} ${item.title}.`, item.description);
}

export function glossaryOgCard(item: GlossaryItem): OgCardData {
	return {label: glossaryTypeText(item), title: item.title, originalTitle: item.originalTitle, subtitle: 'Глоссарий правил'};
}
